import { P, StyledLink } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

import URL, { url } from "src/consts/urlPaths";

import {
  noOptionsLabel,
  noOptionsLinkLabel,
  searchErrorLabel,
  standardNoOptionsLabel,
} from "../Search.config";

// custom react-select No Options component
const NoOptionsMessage = ({
  isStandardSelect,
  searchError,
  showExploreLink = false,
}) => {
  const label = searchError ? (
    searchErrorLabel
  ) : isStandardSelect ? (
    standardNoOptionsLabel
  ) : (
    <>
      {noOptionsLabel}{" "}
      <StyledLink
        fontSize="1"
        to={showExploreLink ? url(URL.EXPLORE) : url(URL.TEAMS)}
      >
        {noOptionsLinkLabel}
      </StyledLink>
    </>
  );
  return (
    <P color="black" fontSize="1">
      {label}
    </P>
  );
};

NoOptionsMessage.propTypes = {
  isStandardSelect: PropTypes.bool,
  searchError: PropTypes.object,
  showExploreLink: PropTypes.bool,
};
export default NoOptionsMessage;
